import cn from "classnames"

import { Flex, Text } from "@/atoms"
import { Heading } from "@/molecules/Heading"

import styles from "./Description.module.scss"

import type { DescriptionProps } from "./Description.types"

export const Description = (props: DescriptionProps) => {
  const { children, title, gap = 10, level = 4 } = props
  const isString = typeof children === "string"

  return (
    <Flex vertical gap={gap} className={cn("i-trans-adr", styles.container)}>
      <Heading level={level} title={title} />
      {isString && <Text>{children}</Text>}
      {!isString && children}
    </Flex>
  )
}
